import { render, staticRenderFns } from "./PlusCircle.vue?vue&type=template&id=6fa3c0bf&"
import script from "./PlusCircle.vue?vue&type=script&lang=ts&"
export * from "./PlusCircle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports